// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"Accordion_accordionWrapper__FTpps","accordionList":"Accordion_accordionList__2ds9D"};